import { useLang } from "../../context/LanguageContext";
import BrandLogo from "../BrandLogo";
import { images } from "../../data/content";

const Footer = () => {
  const { t, isAr } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer
      className="bg-[#0A2520] text-bg-ivory py-10 px-6 md:px-10 lg:px-14"
      data-testid="footer"
    >
      <div className="max-w-[1760px] mx-auto">
        <div className="editorial-rule-dark mb-8" />
        <div className="grid grid-cols-12 gap-6 items-center">
          <div className="col-span-12 md:col-span-4 label-meta text-bg-ivory/65">
            © {year} BIGBRAND — INDUSTRIAL MANUFACTURING
          </div>
          <div className="col-span-12 md:col-span-4 flex justify-center">
            <BrandLogo height={22} theme="light" />
          </div>
          <div
            className={`col-span-12 md:col-span-4 flex ${isAr ? "justify-start [direction:ltr]" : "justify-end"}`}
          >
            <img
              src={images.vision2030}
              alt={t("رؤية المملكة 2030", "Saudi Vision 2030")}
              className="h-10 w-auto object-contain opacity-90"
              data-testid="footer-vision-logo"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
